import {
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  collection,
  query,
  orderBy,
  getDocs,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../config/firebase";

const INVITATIONS_COLLECTION = "invitations";

/**
 * Create an invitation for a new user
 * The invited user will receive this role when they first log in
 */
export async function createInvitation({ email, role, invitedBy }) {
  const inviteId = email.toLowerCase().replace(/[^a-z0-9]/g, "_");
  const docRef = doc(db, INVITATIONS_COLLECTION, inviteId);

  // Check if already invited
  const existing = await getDoc(docRef);
  if (existing.exists()) {
    throw new Error("User has already been invited");
  }

  await setDoc(docRef, {
    email: email.toLowerCase(),
    role,
    invitedBy,
    status: "pending",
    createdAt: serverTimestamp(),
  });

  return { id: inviteId, email, role };
}

/**
 * Get a pending invitation by email
 */
export async function getInvitationByEmail(email) {
  const inviteId = email.toLowerCase().replace(/[^a-z0-9]/g, "_");
  const docRef = doc(db, INVITATIONS_COLLECTION, inviteId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists() && docSnap.data().status === "pending") {
    return { id: docSnap.id, ...docSnap.data() };
  }
  return null;
}

/**
 * Mark an invitation as accepted
 */
export async function acceptInvitation(email) {
  const inviteId = email.toLowerCase().replace(/[^a-z0-9]/g, "_");
  const docRef = doc(db, INVITATIONS_COLLECTION, inviteId);

  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    await setDoc(
      docRef,
      {
        status: "accepted",
        acceptedAt: serverTimestamp(),
      },
      { merge: true }
    );
  }
}

/**
 * Delete/revoke an invitation
 */
export async function revokeInvitation(email) {
  const inviteId = email.toLowerCase().replace(/[^a-z0-9]/g, "_");
  const docRef = doc(db, INVITATIONS_COLLECTION, inviteId);
  await deleteDoc(docRef);
}

/**
 * List all invitations
 */
export async function listInvitations() {
  const q = query(
    collection(db, INVITATIONS_COLLECTION),
    orderBy("createdAt", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

/**
 * List pending invitations only
 */
export async function listPendingInvitations() {
  const q = query(
    collection(db, INVITATIONS_COLLECTION),
    where("status", "==", "pending"),
    orderBy("createdAt", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}
